import { useEffect, useState } from "react";
import { api } from "./api";

// Cache module-level : un seul fetch par session, partagé entre tous les composants
let _cache = null;
let _promise = null;
const _listeners = new Set();

export function resetPermissionsCache() {
  _cache = null;
  _promise = null;
  _listeners.forEach((fn) => fn(null));
}

function fetchPerms() {
  if (!_promise) {
    _promise = api
      .get("/vendor/team/me/permissions")
      .then(({ data }) => {
        _cache = data;
        _listeners.forEach((fn) => fn(data));
        return data;
      })
      .catch(() => {
        _cache = { is_owner: true, permissions: {} };
        _listeners.forEach((fn) => fn(_cache));
        return _cache;
      });
  }
  return _promise;
}

export function usePermissions() {
  const [perms, setPerms] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    _listeners.add(setPerms);
    fetchPerms();
    return () => _listeners.delete(setPerms);
  }, []);

  const can = (module, action = "read") => {
    if (!perms) return true; // pendant le chargement : ne rien masquer (évite le flicker)
    if (perms.is_owner) return true;
    return !!perms.permissions?.[module]?.[action];
  };
  return { can, isOwner: perms?.is_owner ?? true, loaded: !!perms };
}
